import React, { ReactNode } from 'react'

interface PageProps {
  children?: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const PageContainer : React.FC<PageProps> = ({children,className,style}) => {
    let thisstyle = {
        borderRadius:'10px',
        boxShadow: 'rgba(244, 244, 244, 0.4) 0px 5px 15px',
        backgroundColor:'#ffffff59',
        overflow:'auto',
        padding:'25px',
        width:'100%',
        height:'100%',
        minHeight: 'calc(100vh - 200px)',
        ...style
    }
  return (
    <div style={{...thisstyle}} className={className}>
      {children}
    </div>
  )
}

export default PageContainer
